import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Atol2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ATOL2;
}

export default Atol2PoiTileEntity;
